(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){const field=event.target.closest('.elvaya-option-group');if(!field||event.target.type!=='radio')return;const label=field.querySelector('[data-elvaya-selected-value]');if(label)label.textContent=event.target.value;});
  } catch(e) { console.error(e); }
})();

})();
